import React from "react";
import Logoicon from "../../assets/images/dashboard.png";

const Logo = () => {
  return (
    <div>
      <img src={Logoicon} alt="" width={30} />
    </div>
  );
};

export default Logo;
